module.exports = {
  displayName: 'MASTER DATA MANAGEMENT',
  description: 'Manage the master data',
  sortOrder: 1,
  name: 'mdm',
  documentKey: 'mdm',
  sections: {
  },
};
